// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { makeStyles, tokens } from '@fluentui/react-components';
import { assert, CoursePlatform } from '@microsoft/vscodeedu-api';
import React, { useMemo } from 'react';
import { getFetchUrl } from '../../utilities';

const useStyles = makeStyles({
    root: {
        width: '100%',
        aspectRatio: '220/93',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderRadius: tokens.borderRadiusMedium,
    },
});

// Curriculum image cell properties.
export type ImageCellProps = Readonly<{
    imageUrl?: string;
    platform: CoursePlatform;
}>;

// Curriculum image data grid cell contents.
export default (props: ImageCellProps) => {
    const { imageUrl, platform } = props;
    const styles = useStyles();

    const url = useMemo(() => {
        if (imageUrl === undefined) {
            switch (platform) {
                case 'html':
                    return getFetchUrl('curriculum-html.png');
                case 'python':
                    return getFetchUrl('curriculum-python.png');
                default:
                    assert.unreachable();
            }
        } else {
            return imageUrl;
        }
    }, [imageUrl, platform]);

    return <div className={styles.root} aria-hidden style={{ backgroundImage: `url('${url}')` }} />;
};
